import Highcharts from 'utils/highcharts';
import { highchartsOptionsSetter } from 'utils/highchartsOptionsSetter';

highchartsOptionsSetter(Highcharts);
interface IChartType {
  series: { remove: () => void }[];
  addSeries: (param: Record<string, any>) => void;
}

export class PrescriptionStatusChart {
  config: any;

  chart?: IChartType;

  constructor(containerId: string, isExpired: boolean, configObject: any) {
    let config;

    if (isExpired) {
      config = {
        ...configObject,
        plotOptions: {
          solidgauge: {
            dataLabels: {
              y: -13,
              format:
                '<div class="prescription-chart-label medium"><span class="label-medium">{point.x}</span></div>',
              useHTML: true,
            },
          },
        },
      };
    } else {
      config = { ...configObject };
    }
    config.chart.renderTo = containerId;
    this.config = config;
  }

  drawChart() {
    // eslint-disable-next-line
    // @ts-ignore
    this.chart = new Highcharts.chart(this.config);
  }

  addSeries(series: Record<string, any>) {
    if (!this.chart) return;
    if (this.chart.series[0]) {
      this.chart.series[0].remove();
    }
    this.chart.addSeries(series);
  }
}
